export interface Approver {
  id: number;
  email: string;
  fullName: string;
  module: string;
  isActive: boolean;
  notes?: string;
  createdAt?: string;
  createdBy?: string;
}

export interface ApproverRequest {
  email: string;
  fullName: string;
  module: string;
  isActive: boolean;
  notes?: string;
}

export const ApproverModules = {
  INCOME_RECEIPTS: 'IncomeReceipts',
  EXPENSE_VOUCHERS: 'ExpenseVouchers',
  REFUND_VOUCHERS: 'RefundVouchers'
} as const;

export type ApproverModule = typeof ApproverModules[keyof typeof ApproverModules];
